jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus-2024')) {
    const chart2024Q2FutureGrowth = document.getElementById('2024-q2-futuregrowth');

    new Chart(chart2024Q2FutureGrowth, {
      type: 'bar',
      data: {
        labels: ['Q4 2023', 'Q1 2024', 'Q2 2024'],
        datasets: [{
          label: 'Significant Growth',
          data: ['25.8', '30.8', '29.3'],
          backgroundColor: '#0064dd',
          borderColor: '#0064dd',
        },
        {
          label: 'Moderate Growth',
          data: ['65.8', '61.8', '62.2'],
          backgroundColor: '#000082',
          borderColor: '#000082',
        },
        {
          label: 'No Growth',
          data: ['8.4', '7.3', '8.5'],
          backgroundColor: '#83dcc1',
          borderColor: '#83dcc1',
        }]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            border: { display: false },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            max: 70,
          }
        }
      }
    });

    const chart2024Q2Median = document.getElementById('2024-q2-median');

    new Chart(chart2024Q2Median, {
      type: 'line',
      data: {
        labels: ['Jun\'23', 'Jul\'23', 'Aug\'23', 'Sep\'23', 'Oct\'23', 'Nov\'23', 'Dec\'23', 'Jan\'24', 'Feb\'24', 'Mar\'24', 'Apr\'24', 'May\'24', 'Jun\'24'],
        datasets: [{
          label: 'Median Revenue by Month',
          data: ['56000', '54490', '59440', '56517', '62506', '59703', '59005', '57037', '54061', '53529', '55500', '54480', '50910'],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Revenue',
            },
            ticks: {
              stepSize: 10000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              }
            },
            min: 35000,
            max: 75000,
          }
        }
      }
    });

    const chart2024Q2RevToExp = document.getElementById('2024-q2-revtoexp');

    new Chart(chart2024Q2RevToExp, {
      type: 'line',
      data: {
        labels: ['Jun\'23', 'Jul\'23', 'Aug\'23', 'Sep\'23', 'Oct\'23', 'Nov\'23', 'Dec\'23', 'Jan\'24', 'Feb\'24', 'Mar\'24', 'Apr\'24', 'May\'24', 'Jun\'24'],
        datasets: [{
          label: 'Cleveland only',
          data: ['98.18', '98.31', '98.34', '99.54', '99.56', '98.84', '99.34', '100.06', '100.40', '100.00', '100.25', '99.98', '99.06'],
          borderColor: '#83dcc1',
          backgroundColor: '#83dcc1',
          pointBackgroundColor: '#83dcc1',
        },
        {
          label: 'Boston only',
          data: ['101.49', '101.58', '99.81', '99.62', '100.88', '99.89', '99.95', '99.66', '100.13', '101.46', '100.63', '100.27', '101.30'],
          borderColor: '#000082',
          backgroundColor: '#000082',
          pointBackgroundColor: '#000082',
        },
        {
          label: 'U.S.',
          data: ['100.03', '100.17', '99.78', '99.35', '100.41', '99.58', '99.88', '100.27', '100.85', '101.10', '100.93', '100.29', '99.97'],
          borderColor: '#0064dd',
          backgroundColor: '#0064dd',
          pointBackgroundColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { reverse: true },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label.replace(/ only/g, '') || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 95,
            max: 105,
          }
        }
      }
    });

    const chart2024Q2PayToRev = document.getElementById('2024-q2-paytorev');

    new Chart(chart2024Q2PayToRev, {
      type: 'line',
      data: {
        labels: ['Jun\'23', 'Jul\'23', 'Aug\'23', 'Sep\'23', 'Oct\'23', 'Nov\'23', 'Dec\'23', 'Jan\'24', 'Feb\'24', 'Mar\'24', 'Apr\'24', 'May\'24', 'Jun\'24'],
        datasets: [{
          label: 'Philadelphia only',
          data: ['21.04', '18.80', '19.61', '19.05', '17.42', '21.56', '22.60', '18.74', '20.80', '19.14', '17.73', '20.82', '18.71'],
          borderColor: '#83dcc1',
          backgroundColor: '#83dcc1',
          pointBackgroundColor: '#83dcc1',
        },
        {
          label: 'Boston only',
          data: ['18.78', '18.17', '19.38', '20.72', '17.11', '21.33', '20.40', '18.65', '21.07', '20.57', '17.68', '20.71', '20.16'],
          borderColor: '#000082',
          backgroundColor: '#000082',
          pointBackgroundColor: '#000082',
        },
        {
          label: 'U.S.',
          data: ['19.35', '17.47', '18.52', '19.35', '17.71', '20.09', '20.29', '17.93', '19.79', '19.21', '17.60', '19.59', '18.63'],
          borderColor: '#0064dd',
          backgroundColor: '#0064dd',
          pointBackgroundColor: '#0064dd',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { reverse: true },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label.replace(/ only/g, '') || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 14,
            max: 24,
          }
        }
      }
    });

    const chart2024Q2AltPay = document.getElementById('2024-q2-altpay');

    new Chart(chart2024Q2AltPay, {
      type: 'line',
      data: {
        labels: ['Jun\'23', 'Jul\'23', 'Aug\'23', 'Sep\'23', 'Oct\'23', 'Nov\'23', 'Dec\'23', 'Jan\'24', 'Feb\'24', 'Mar\'24', 'Apr\'24', 'May\'24', 'Jun\'24'],
        datasets: [{
          label: 'Alternative Payments Accepted',
          data: ['24.83', '24.04', '24.19', '23.58', '23.54', '23.16', '23.46', '24.72', '25.46', '26.59', '27.83', '28.29', '28.32'],
          borderColor: '#0064dd',
          pointBackgroundColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Percentage',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 20,
            max: 30,
          }
        }
      }
    });
  }
});
